import { render } from "./quePage.vue?vue&type=template&id=4e18c299&scoped=true"
import script from "./quePage.vue?vue&type=script&lang=js"
export * from "./quePage.vue?vue&type=script&lang=js"

import "./quePage.vue?vue&type=style&index=0&id=4e18c299&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e18c299"]])

export default __exports__